import { Drawer } from '../shared/Drawer';
import { useMediaQuery } from '@mui/material';
import BulkAssignmentChangeModal from './BulkAssignmentChangeModal';
import { BriefDebriefCallDocument } from 'types';

interface Props {
	isOpen: boolean;
	selectedPosition?: string;
	userIds?: string[];
	scheduleType?: 'request' | 'schedule';
	rescheduleCallId?: string;
	onClose: () => void;
	callDetails?: BriefDebriefCallDocument;
}

const BriefDebriefModalV2 = ({
	isOpen,
	onClose,
	selectedPosition,
	scheduleType,
	rescheduleCallId,
	userIds,
	callDetails,
}: Props) => {
	const isMobile = useMediaQuery('(max-width:960px)');
	return (
		<Drawer
			maxHeight="90dvh"
			modalMaxWidth="1000px"
			minHeight={'max-content'}
			backDropColor={'rgba(0, 0, 0, 0.5)'}
			boxShadow="0px -8px 32px 0px #00000040"
			isModal={!isMobile}
			isOpen={isOpen}
			onClose={onClose}
			header={<h1 className="text-2xl font-bold pt-4 px-5">Schedule Brief/Debrief Call</h1>}
			body={
				<div className="p-2">
					<BulkAssignmentChangeModal
						callDetails={callDetails}
						defaultSelectedUserIds={userIds}
						selectedPosition={selectedPosition}
						scheduleType={scheduleType}
						rescheduleCallId={rescheduleCallId}
						drawerType={'schedule-brief-debrief-call'}
						ctaText="Schedule Call"
					/>
				</div>
			}
		/>
	);
};

export default BriefDebriefModalV2;
